/**
 * Tema stagionale — attiva/disattiva da sola in base alla data.
 *
 * Halloween: 1 ottobre → 31 ottobre incluso (ora locale del browser).
 * Dal 1 novembre l'attributo non viene più messo e il sito torna
 * al design originale senza bisogno di un nuovo deploy.
 *
 * Override per anteprima (non persiste tra sessioni):
 *   ?season=halloween  forza il tema
 *   ?season=off        lo disattiva
 */

const SEASONS = {
  halloween: {
    // mesi 0-based: 9 = ottobre
    isActive: (d) => d.getMonth() === 9,
    // decorazioni iniettate nel DOM
    decorations: () => {
      const overlay = document.createElement('div');
      overlay.className = 'hw-overlay';
      overlay.setAttribute('aria-hidden', 'true');

      // pipistrelli: quota, durata e altezza sfalsate
      const bats = [
        { top: '12%', duration: 26, delay: 0,  scale: 1    },
        { top: '34%', duration: 38, delay: 7,  scale: 0.7  },
        { top: '62%', duration: 31, delay: 14, scale: 0.85 },
      ];
      bats.forEach(({ top, duration, delay, scale }) => {
        const bat = document.createElement('span');
        bat.className = 'hw-bat';
        bat.style.top = top;
        bat.style.animationDuration = `${duration}s`;
        bat.style.animationDelay = `-${delay}s`;
        bat.style.width = `${46 * scale}px`;   // scala senza toccare transform,
        bat.style.height = `${16 * scale}px`;  // usato dall'animazione di volo
        overlay.appendChild(bat);
      });

      ['left', 'right'].forEach((side) => {
        const web = document.createElement('span');
        web.className = `hw-web hw-web--${side}`;
        overlay.appendChild(web);
      });

      const spider = document.createElement('span');
      spider.className = 'hw-spider';
      overlay.appendChild(spider);

      return overlay;
    },
  },
};

const OVERLAY_SELECTOR = '.hw-overlay';

function readOverride() {
  try {
    const fromUrl = new URLSearchParams(window.location.search).get('season');
    if (fromUrl) {
      sessionStorage.setItem('season-override', fromUrl);
      return fromUrl;
    }
    return sessionStorage.getItem('season-override');
  } catch {
    // sessionStorage può lanciare in modalità privata: l'override è opzionale
    return null;
  }
}

function currentSeason(now = new Date()) {
  const override = readOverride();
  if (override === 'off') return null;
  if (override && SEASONS[override]) return override;

  return Object.keys(SEASONS).find((name) => SEASONS[name].isActive(now)) || null;
}

function clearDecorations() {
  document.querySelectorAll(OVERLAY_SELECTOR).forEach((el) => el.remove());
}

function apply() {
  const season = currentSeason();
  const root = document.documentElement;

  if (!season) {
    root.removeAttribute('data-season');
    clearDecorations();
    return;
  }

  if (root.getAttribute('data-season') === season) return; // già applicato

  root.setAttribute('data-season', season);
  clearDecorations();

  const build = SEASONS[season].decorations;
  if (build && document.body) document.body.appendChild(build());
}

/** Rivaluta allo scoccare della mezzanotte, così il tema scade da solo
 *  anche in una scheda rimasta aperta. */
function scheduleMidnightCheck() {
  const now = new Date();
  const midnight = new Date(now);
  midnight.setHours(24, 0, 5, 0); // 5s dopo per evitare corse sul confine

  setTimeout(() => {
    apply();
    scheduleMidnightCheck();
  }, midnight - now);
}

export default function initSeasonalTheme() {
  apply();
  scheduleMidnightCheck();
}
